import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { storage } from 'utils/storage';
import en from 'assets/translations/en.json';
import de from 'assets/translations/de.json';
import fr from 'assets/translations/fr.json';
import it from 'assets/translations/it.json';

const resources = {
  en: { translation: en },
  de: { translation: de },
  fr: { translation: fr },
  it: { translation: it },
};

i18n.use(initReactI18next).init({
  resources,
  lng: storage.get('lng') || 'de',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
